import { useEffect, useState } from 'react';
import useClient from 'api/client';
import listNotifications from 'api/Notification/listNotifications';
import markNotificationAsRead from 'api/Notification/markAsRead';
import {
    ListNotifications,
    NotificationItem,
    NotificationsResponse,
} from 'types/Notification';
import { SearchFilter } from 'types/Filters';
import { useLocation } from 'react-router-dom';
import { getPageNumber } from 'components/pager/getPageDetails';

const useNotifications = () => {
    const location = useLocation();
    const client = useClient() as any;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [filter, setFilter] = useState<SearchFilter>({
        page: getPageNumber(location.search),
        pageSize: 10,
        unread: false,
        sort: [
            {
                field: 'created',
                direction: 'desc',
            },
        ],
    });
    const [items, setItems] = useState<ListNotifications>({
        nodes: [],
        count: 0,
        page: 0,
        pages: 0,
    });

    const markAsRead = (notificationUri: string) => {
        client?.mutate(markNotificationAsRead(notificationUri));
    };
    const markAllAsRead = async () => {
        setLoading(true);
        const unreads = await client.query(
            listNotifications({
                page: 1,
                pageSize: items.count,
                unread: true,
            }),
        );
        unreads.data.listNotifications?.nodes.forEach(
            (notification: NotificationItem) => {
                markAsRead(notification.notificationUri);
            },
        );
        setFilter({ ...filter, page: 1 });
    };

    useEffect(() => {
        if (client) {
            setLoading(true);
            client
                .query(listNotifications(filter))
                .then((response: NotificationsResponse) => {
                    if (response.errors) {
                        setError(true);
                        setLoading(false);
                    } else {
                        setItems(response.data.listNotifications);
                        setLoading(false);
                    }
                });
        }
    }, [client, filter]);

    return {
        items,
        loading,
        error,
        filter,
        setFilter,
        markAllAsRead,
        markAsRead,
    };
};

export default useNotifications;
